// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vajax from './assets/js/vue-ajax.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './common/less/common.less'
import 'swiper/dist/css/swiper.css'
import check from './assets/js/check.js'
import 'element-ui/lib/theme-chalk/index.css'
import 'url-search-params-polyfill'
import qs from 'qs'

import { Loading } from 'element-ui'
Vue.use(Loading)
// Vue.component(Loading.name, Loading)

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(Vajax)
Vue.use(check)
Vue.prototype.$qs = qs

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js